module.exports = __webpack_public_path__ + "assets/img/9_95_big.77d9eef5.jpg";